/* Click-to-load embeds keep the homepage fast and playback intentional. */
(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-ch-mode-console]').forEach(console => {
      if (console.dataset.ready) return;
      console.dataset.ready = 'true';
      const buttons = [...console.querySelectorAll('[data-ch-mode]')];
      const panels = [...console.querySelectorAll('[data-ch-mode-panel]')];
      const show = mode => {
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.chMode === mode)));
        panels.forEach(panel => { panel.hidden = panel.dataset.chModePanel !== mode; });
      };
      show('47');
      buttons.forEach(button => button.addEventListener('click', () => show(button.dataset.chMode)));
    });
    root.querySelectorAll('[data-ch-component]').forEach(link => {
      if (link.dataset.ready) return;
      link.dataset.ready = 'true';
      link.addEventListener('click', event => {
        const target = document.getElementById(link.hash.slice(1));
        if (!target) return;
        event.preventDefault();
        target.open = true;
        target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
        target.querySelector('summary')?.focus({ preventScroll: true });
      });
    });
    root.querySelectorAll('[data-ch-video]').forEach(stage => {
      if (stage.dataset.ready) return;
      stage.dataset.ready = 'true';
      const trigger = stage.querySelector('button');
      trigger?.addEventListener('click', () => {
        const id = stage.dataset.chVideo;
        if (!/^[\w-]{11}$/.test(id)) return;
        const player = document.createElement('iframe');
        player.src = `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&playsinline=1&rel=0`;
        player.title = stage.dataset.chVideoTitle || 'WLV-01 — Camera Hacks hero film';
        player.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        player.allowFullscreen = true;
        player.referrerPolicy = 'strict-origin-when-cross-origin';
        stage.replaceChildren(player);
        player.focus();
      });
    });
    root.querySelectorAll('.ch-mobile-menu a').forEach(link => {
      if (link.dataset.ready) return;
      link.dataset.ready = 'true';
      link.addEventListener('click', () => link.closest('details').removeAttribute('open'));
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.ch-mobile-menu[open]').forEach(menu => {
      menu.removeAttribute('open');
      menu.querySelector('summary').focus();
    });
  });
})();
